(function (){
    'use strict';

    angular
        .module('app')
        .config(AppConfig);
    //  'ui.select','ui.bootstrap',
    AppConfig.$injector = ['$httpProvider', 'jwtInterceptorProvider', '$urlRouterProvider', 'AclServiceProvider', '$sceDelegateProvider', '$routeProvider', '$stateProvider'];

    function AppConfig ($httpProvider, jwtInterceptorProvider, $urlRouterProvider, AclServiceProvider, $sceDelegateProvider, $routeProvider, $stateProvider) {

        var myConfig = {
            storage: 'localStorage',
            storageKey: 'AclService'
        };

        AclServiceProvider.config(myConfig);

        jwtInterceptorProvider.tokenGetter = ['jwtHelper', '$http', function (jwtHelper, $http) {
            var source =localStorage.getItem('fpp_source');
            var idToken = localStorage.getItem('id_token');
            var refreshToken = localStorage.getItem('refresh_token');
            if (idToken === null) {
                //$urlRouterProvider.otherwise("/auth/login");
                return null;
            }
            if (jwtHelper.isTokenExpired(idToken)) {
                localStorage.removeItem('id_token');
                //urlRouterProvider.otherwise("/auth/login");
                return null;
            } else {
                return idToken;
            }
        }];
        $httpProvider.interceptors.push('jwtInterceptor');

        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            'http://fppadmin.local/**',
            'http://fppadmin.fpp.world/**'
          ]);
    }
})();
